import React from "react";
import moment from "moment";
import { useGetBookingGroupSectionQuery } from "@graphql";
import locale from "@bonliva-crm/locale";
import ProfileSection from "@components/ProfileSection";
import { WorkRequestPeriods } from "../../components/week-periods";

type Props = {
  bookingGroupId: string;
  onWeekChange: (bookingId: string) => void;
  week: Date;
};

export const BookingGroupSection: React.FC<Props> = (props) => {
  const { bookingGroupId } = props;

  const { data, error } = useGetBookingGroupSectionQuery({
    fetchPolicy: "cache-first",
    variables: { bookingGroupId }
  });

  if (!data || error) {
    return null;
  }

  const getBookingId = (week: Date) => {
    const booking = data.getBookingGroup.bookings.find((x) =>
      moment.utc(x.Week).isSame(week, "isoWeek")
    );

    return booking ? booking._id : null;
  };

  const bookingDurations = data.getBookingGroup.bookings.map((x) => ({
    From: x.Week,
    To: x.Week
  }));

  return (
    <ProfileSection collapsible={false} title={locale.BookingGroup}>
      <WorkRequestPeriods
        onChange={() => null}
        onClick={(week) => {
          const id = getBookingId(week);
          id && props.onWeekChange(id);
        }}
        bookings={bookingDurations}
        value={[{ From: props.week, To: props.week }]}
      />
    </ProfileSection>
  );
};
